import { useState } from "react";
import axiosInstance from "../../config/axiosConfig";
import { formatDate, formatMoney} from "../../utils/utils";

const Ingresos = () => {
  const [showModal, setShowModal] = useState(false);
  const [periodo, setPeriodo] = useState(new Date().toISOString().slice(0, 7)); // Mes actual
  const [filteredIngresos, setFilteredIngresos] = useState([]);

  const [ingresos, setIngresos] = useState();

  const filtrarIngresos = async () => {
    try {
      // Llamada a la API para obtener los movimientos por periodo
      const response = await axiosInstance.post("/financiero/cartola/ingresos", { periodo });

      const movimientosFiltrados = response.data.data;
      setIngresos(movimientosFiltrados);
      setFilteredIngresos(movimientosFiltrados);

    } catch (error) {
      console.error("Error al obtener los movimientos:", error);
    }
  };

  // Calcular total de ingresos filtrados
  const totalIngresos = filteredIngresos.reduce((acc, ingreso) => acc + parseInt(ingreso.monto), 0);

  return (
    <div className="container mt-4">
      <div className="card p-4 shadow">
        {/* Encabezado */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h3>Ingresos</h3>
        </div>

        {/* Filtros */}
        <div className="row mb-3">
          <div className="col-md-4">
            <label className="form-label">Período:</label>
            <input
              type="month"
              className="form-control"
              value={periodo}
              onChange={(e) => setPeriodo(e.target.value)}
            />
          </div>
          <div className="col-md-2 d-flex align-items-end">
            <button className="btn btn-primary" onClick={filtrarIngresos}>
              Buscar
            </button>
          </div>
        </div>

        {/* Indicador de Total de Ingresos */}
        <div className="alert alert-success">
          <strong>Total de Ingresos:</strong> ${formatMoney(totalIngresos)}
        </div>

        {/* Tabla de Ingresos */}
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Fecha</th>
              <th>Título</th>
              <th>Monto</th>
              <th>Comentario</th>
            </tr>
          </thead>
          <tbody>
            {filteredIngresos.length > 0 ? (
              filteredIngresos.map((ingreso) => (
                <tr key={ingreso.id_movimiento}>
                  <td>{formatDate(ingreso.fecha)}</td>
                  <td>{ingreso.detalle}</td>
                  <td>${formatMoney(ingreso.monto)}</td>
                  <td>{ingreso.observacion}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={4} className="text-center text-muted">
                  No hay ingresos para este período.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Fondo Oscuro para Modal */}
      {showModal && <div className="modal-backdrop fade show" onClick={() => setShowModal(false)}></div>}
    </div>
  );
};

export default Ingresos;
